namespace Areas.Employee.License {
    "use strict";

    export function newLicense(e) {
        e.data.employeeId = $('#LicenseGrid').dxDataGrid('instance').option('EmployeeId');
    }

}
